import HTTPClient from '../..'
import { Member } from '@services/nomos_api/entities/user'

export const deleteUserAPI = async (id: string) => {
  const { data } = await HTTPClient.delete(`users/${id}`)
  return data as Member
}
